import { render, staticRenderFns } from "./AccRmaReviews.vue?vue&type=template&id=755e9f2a&scoped=true&"
import script from "./AccRmaReviews.vue?vue&type=script&lang=js&"
export * from "./AccRmaReviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755e9f2a",
  null
  
)

export default component.exports